export default __webpack_public_path__ + "static/media/RewardsCards-2.c182aff0.png";